import getRoutes from '../routes'
import { getTypeProfile } from '../fonction'

const useGetSubRoutes = (filterTypeRoute = undefined) => {
  const { typeProfile, isSuperAdmin } = getTypeProfile()

  return (
    getRoutes()
      .filter((i) => {
        // Si c'est une sous route, on la disqualifie ici (c'est traité plus bas)
        if (i.subMenu?.length > 0) return false

        // La page est cachée, on n'affiche pas cette route
        if (i.display === false) return false

        // ?? à commenter, je ne sais pas ce que c'est sensé faire
        if (
          (filterTypeRoute !== null &&
            (filterTypeRoute !== i.typeRoute || i.displaySubMenu === false)) ||
          filterTypeRoute === undefined
        )
          return false

        // Est ce que cette route est disponible pour ce type d'utilisateur ?
        if (!!i.onlyFor && !i.onlyFor?.includes(typeProfile)) return false

        return true
      })
      // On va checher les sous routes
      .map((iRoute) => {
        const subRoute = getRoutes().filter(
          (iSubRoute) =>
            !!iSubRoute.subMenu &&
            iSubRoute.subMenu.includes(iRoute.title) &&
            iSubRoute.display !== false &&
            !!iSubRoute.onlyFor &&
            iSubRoute.onlyFor.indexOf(typeProfile) >= 0 &&
            (!iSubRoute.superAdmin || (!!iSubRoute.superAdmin && !!isSuperAdmin))
        )

        return {
          ...iRoute,
          subRoute: subRoute,
        }
      })
  )
}

const getStepsRegistar = () => {
  const { typeProfile } = getTypeProfile()

  return getRoutes().filter((i) => i.onlyFor && i.registar && i.onlyFor.indexOf(typeProfile) >= 0)
}

export { useGetSubRoutes, getStepsRegistar }
